import type { IAppsSignalFilters } from "app/pages/sales-intelligence/domain/signals/types/apps-signal";
import type { SignalTimeframeOption, SignalTimeframePeriod } from "app/pages/sales-intelligence/domain/signals/types/timeframe";
import { signalTimeframePeriodMap } from "app/pages/sales-intelligence/domain/signals/types/timeframe";

import type { SignalTimeframe, SignalTimeframeConfig } from "../miscellaneous/SignalTimeframe";

export const appsSignalTimeframeConfig: SignalTimeframeConfig<IAppsSignalFilters> = {
    options: [
        { amount: 1, id: signalTimeframePeriodMap.day },
        { amount: 1, id: signalTimeframePeriodMap.week },
        { amount: 2, id: signalTimeframePeriodMap.week },
        { amount: 3, id: signalTimeframePeriodMap.week },
        { amount: 1, id: signalTimeframePeriodMap.month },
        { amount: 3, id: signalTimeframePeriodMap.month },
        { amount: 6, id: signalTimeframePeriodMap.month },
        { amount: 1, id: signalTimeframePeriodMap.year },
    ] satisfies readonly SignalTimeframeOption[],
    fromFilters(filters: Readonly<Partial<IAppsSignalFilters>>) {
        const { period, periodAmount } = filters.appsSdks ?? {};

        if (period == null || periodAmount == null) {
            return undefined;
        }

        return { amount: periodAmount, id: period };
    },
    toFilters(timeframe: Readonly<SignalTimeframe>) {
        return {
            appsSdks: {
                period: timeframe.id as SignalTimeframePeriod,
                periodAmount: timeframe.amount,
            },
        };
    },
};

export default appsSignalTimeframeConfig;
